import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { setMeta } from '../utils/seo';

function Clubs() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });
    setMeta({
      title: 'HHpoker俱乐部ID推荐｜俱乐部加入与筛选指南',
      description: '提供HHpoker俱乐部ID与加入流程，包含俱乐部筛选建议、活跃度判断、入驻步骤与常见问题，帮助用户快速加入合适战队。',
      keywords: 'HHpoker俱乐部ID推荐, HHpoker俱乐部推荐, 德扑圈战队ID, 德州扑克俱乐部入驻',
      url: window.location.origin + '/clubs/',
      robots: 'index,follow',
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "hhpoker俱乐部id怎么找？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "可先看本页推荐与筛选规则，再按引导完成加入流程。"
            }
          },
          {
            "@type": "Question",
            "name": "hhpoker俱乐部id推荐看什么指标？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "建议重点看活跃度、局级匹配、规则透明度和客服响应效率。"
            }
          },
          {
            "@type": "Question",
            "name": "hhpoker俱乐部id号有哪些？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "以本页实时更新列表为准，优先选择信息完整且支持问题闭环的俱乐部。"
            }
          },
          {
            "@type": "Question",
            "name": "hhpoker俱乐部玩家群有哪些？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "可通过本页俱乐部入口了解对应社群与参与方式，先确认规则再加入。"
            }
          },
          {
            "@type": "Question",
            "name": "新手加入俱乐部怎么降低试错成本？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "先从低门槛和新手支持完善的俱乐部试参与，再逐步升级局级。"
            }
          }
        ]
      }
    });
  }, []);

  const clubs = [
    { name: '皇家永利战队', id: '100888', stars: 5, tags: ['福利多', '高分局'] },
    { name: '竞技圈豪门汇', id: '666888', stars: 5, tags: ['人气旺', '全级别'] },
    { name: '聚贤庄', id: '888999', stars: 5, tags: ['24H客服', '极速响应'] },
    { name: '天天竞技', id: '123456', stars: 4, tags: ['新手场', '低门槛'] },
    { name: '扑克之星', id: '777777', stars: 5, tags: ['比赛多', '奖励高'] },
    { name: '优质联盟', id: '999000', stars: 5, tags: ['稳定', '安全'] },
  ];

  return (
    <div style={{ background: '#1a1c29', color: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      
      {/* Hero Section */}
      <section style={{
        padding: '120px 8vw 80px',
        background: `linear-gradient(rgba(20,22,34,0.9), rgba(20,22,34,0.8)), url('/images/clubs_bg.jpg') center/cover no-repeat fixed`,
        textAlign: 'center'
      }}>
        <h1 data-aos="fade-down" style={{ fontSize: '3.5rem', color: '#efa765', marginBottom: '20px', fontWeight: 800, textShadow: '0 4px 20px rgba(0,0,0,0.5)' }}>
          HHpoker 俱乐部ID推荐
        </h1>
        <p data-aos="fade-up" style={{ fontSize: '1.2rem', color: '#e0e0e0', maxWidth: '700px', margin: '0 auto 40px', lineHeight: 1.6 }}>
          严选优质高信誉俱乐部，资金安全有保障，24小时客服在线服务。<br/>
          <span style={{ color: '#efa765' }}>推荐指数：★★★★★</span> &nbsp; <span style={{ color: '#efa765' }}>实力指数：★★★★★</span>
        </p>
      </section>

      {/* Clubs Grid */}
      <section style={{ padding: '60px 8vw', background: '#1a1c29', flex: 1 }}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
          gap: '30px',
          maxWidth: '1200px',
          margin: '0 auto' 
        }}>
          {clubs.map((club, index) => (
            <div key={index} data-aos="fade-up" data-aos-delay={index * 100} style={{
              background: '#232533',
              borderRadius: '16px',
              padding: '30px',
              border: '1px solid #333',
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.4)';
              e.currentTarget.style.borderColor = '#efa765';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
              e.currentTarget.style.borderColor = '#333';
            }}
            >
              <div style={{ position: 'absolute', top: 0, right: 0, background: '#efa765', color: '#1a1c29', padding: '5px 15px', borderRadius: '0 16px 0 16px', fontWeight: 'bold', fontSize: '0.9rem' }}>
                ID: {club.id}
              </div>
              
              <h3 style={{ fontSize: '1.5rem', color: '#fff', marginBottom: '15px', marginTop: '10px' }}>{club.name}</h3>
              
              <div style={{ marginBottom: '20px', color: '#efa765', fontSize: '1.2rem' }}>
                {'★'.repeat(club.stars)}
              </div>

              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '25px' }}>
                {club.tags.map((tag, i) => (
                  <span key={i} style={{ 
                    background: 'rgba(239,167,101,0.1)', 
                    color: '#efa765', 
                    padding: '4px 12px', 
                    borderRadius: '20px', 
                    fontSize: '0.85rem' 
                  }}>
                    {tag}
                  </span>
                ))}
              </div>

              <Link to="/contact" style={{
                display: 'block',
                width: '100%',
                padding: '12px 0',
                textAlign: 'center',
                background: 'transparent',
                border: '1px solid #efa765',
                color: '#efa765',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: 600,
                transition: 'all 0.3s'
              }}
              onMouseOver={(e) => {
                 e.currentTarget.style.background = '#efa765';
                 e.currentTarget.style.color = '#1a1c29';
              }}
              onMouseOut={(e) => {
                 e.currentTarget.style.background = 'transparent';
                 e.currentTarget.style.color = '#efa765';
              }}
              >
                申请加入
              </Link>
            </div>
          ))}
        </div>

        <div style={{ maxWidth: '1200px', margin: '26px auto 0 auto', background: '#202334', border: '1px solid #2a2d42', borderRadius: '12px', padding: '18px 20px' }}>
          <h2 style={{ color: '#efa765', fontSize: '1.3rem', marginBottom: '10px' }}>俱乐部选择建议</h2>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：hhpoker俱乐部id怎么找？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：可先看本页推荐与筛选规则，再按引导完成加入流程。</p>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：hhpoker俱乐部id推荐看什么指标？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：建议重点看活跃度、局级匹配、规则透明度和客服响应效率。</p>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：hhpoker俱乐部id号有哪些？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：以本页实时更新列表为准，优先选择信息完整且支持问题闭环的俱乐部。</p>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：hhpoker俱乐部玩家群有哪些？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：可通过本页俱乐部入口了解对应社群与参与方式，先确认规则再加入。</p>
          <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：新手加入俱乐部怎么降低试错成本？</strong></p>
          <p style={{ color: '#aeb4c2', marginBottom: '0' }}>A：先从低门槛和新手支持完善的俱乐部试参与，再逐步升级局级。</p>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ background: '#0c0909', padding: '40px 8vw', borderTop: '1px solid #222', textAlign: 'center' }}>
        <p style={{ color: '#555', fontSize: '0.9rem' }}>Copyright © 2026 HHpoker. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default Clubs;
